import { ChipClassKey } from '@mui/material';
import { OverridesStyleRules } from '@mui/material/styles/overrides';
import { getColor, getDarkerColor, getLighterColor } from '../../colors/colors';
import { get } from 'http';

export const CustomChip: Partial<OverridesStyleRules<ChipClassKey>> | undefined = {
  root: {
    '&.deal-status-draft': {
      backgroundColor: getColor('dealStatusDraft'),
      color: getColor('dealStatusDraftContrast'),
    },
    '&.deal-status-in-creation': {
      backgroundColor: getColor('dealStatusInCreation'),
      color: getColor('dealStatusInCreationContrast'),
    },
    '&.deal-status-active': {
      backgroundColor: getColor('dealStatusActive'),
      color: getColor('dealStatusActiveContrast'),
    },
    '&.deal-status-error': {
      backgroundColor: getColor('dealStatusError'),
      color: getColor('dealStatusErrorContrast'),
    },

    '&.organization-status-draft': {
      backgroundColor: getColor('dealStatusDraft'),
      color: getColor('dealStatusDraftContrast'),
    },

    '&.organization-status-active': {
      backgroundColor: getColor('dealStatusActive'),
      color: getColor('dealStatusActiveContrast'),
    },
    '&.organization-status-inactive': {
      backgroundColor: getColor('dealStatusDraft'),
      color: getColor('dealStatusDraftContrast'),
    },

    '&.video-chip': {
      backgroundColor: getColor('video'),
      color: getColor('videoContrast'),
    },
    '&.native-chip': {
      backgroundColor: getColor('native'),
      color: getColor('nativeContrast'),
    },
    '&.cwire-chip': {
      backgroundColor: getColor('cWireFormat'),
      color: getColor('cWireFormatContrast'),
    },
    '&.banner-chip': {
      backgroundColor: getColor('banner'),
      color: getColor('bannerContrast'),
    },

    '&.summary-chip': {
      '& .MuiChip-label': {
        textTransform: 'capitalize',
        color: getColor('text'),
        userSelect: 'none',
      },
    },
    '&.keyword-chip': {
      color: getColor('text'),
      backgroundColor: 'rgba(85, 0, 180, 0.08)', // primary color (#5500B4)
      margin: '0px 5px'
    },
  },
};
